import React from "react";
import "./App.css";
import Die from "./Die";
import { nanoid } from "nanoid";
import Confetti from "react-confetti";

export default function App() {
  const [dice, setDice] = React.useState(allNewDice());
  const [tenzies, setTenzies] = React.useState(false);

  React.useEffect(() => {
    const allHeld = dice.every((die) => die.isHeld);
    const firstval = dice[0].value;
    const allSameValue = dice.every((val) => val.value === firstval);

    if (allHeld && allSameValue) {
      setTenzies(true);
    }
  }, [dice]);

  function allNewDice() {
    const newDice = [];
    for (let i = 0; i < 10; i++) {
      newDice.push(createnewDie());
    }
    return newDice;
  }

  function createnewDie() {
    return {
      value: Math.ceil(Math.random() * 6),
      isHeld: false,
      id: nanoid(),
    };
  }
  function handle() {
    if (!tenzies) {
      setDice((oldDice) =>
        oldDice.map((val) => {
          return val.isHeld ? val : createnewDie();
        })
      );
    } else {
      setTenzies(false);
      setDice(allNewDice());
    }
  }

  function passes(id) {
    setDice((oldDice) =>
      oldDice.map((change) => {
        return change.id === id
          ? { ...change, isHeld: !change.isHeld }
          : change;
      })
    );
  }

  const diceElements = dice.map((die) => (
    <Die
      key={die.id}
      value={die.value}
      isHeld={die.isHeld}
      id={die.id}
      funval={passes}
    />
  ));

  return (
    <main>
      {tenzies === true && <Confetti />}
      <h1 className="title">Tenzies</h1>
      <p className="instructions">
        Roll until all dice are the same. Click each die to freeze it at its
        current value between rolls.
      </p>
      <div className="dice-container">{diceElements}</div>
      <button type="button" className="btn btn-success roll" onClick={handle}>
        {tenzies === true ? "New Roll" : "Roll"}
      </button>
    </main>
  );
}
